/* Hero Slider Home DR - Digital Runner
   Frecce, pallini e autoplay opzionale per sections/hero-slider-home_dr.liquid.
   Supporta piu' slider nella stessa pagina e il ricaricamento nel customizer. */
(function () {
  function init(root) {
    if (!root || root.dataset.hhReady) return;
    root.dataset.hhReady = '1';

    var track = root.querySelector('.hh-slider__track_dr');
    var slides = Array.prototype.slice.call(root.querySelectorAll('.hh-slide_dr'));
    var dotsWrap = root.querySelector('.hh-slider__dots_dr');
    var prev = root.querySelector('.hh-slider__arrow_dr--prev');
    var next = root.querySelector('.hh-slider__arrow_dr--next');
    if (!track || slides.length < 2 || !dotsWrap) return;

    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var current = 0;

    var dots = slides.map(function (slide, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'hh-slider__dot_dr';
      b.setAttribute('aria-label', 'Vai alla slide ' + (i + 1));
      b.addEventListener('click', function () { go(i); restart(); });
      dotsWrap.appendChild(b);
      slide.setAttribute('aria-label', (i + 1) + ' di ' + slides.length);
      return b;
    });

    function mark(i) {
      current = i;
      // Pallini scuri quando la slide attiva ha testi colorati (foto chiara)
      root.classList.toggle('hh-slider_dr--light-active', !!slides[i] && !slides[i].classList.contains('hh-slide_dr--txt-bianco'));
      dots.forEach(function (d, j) {
        d.classList.toggle('is-active', j === i);
        d.setAttribute('aria-current', j === i ? 'true' : 'false');
      });
    }

    function go(i) {
      i = (i + slides.length) % slides.length;
      track.scrollTo({ left: i * track.clientWidth, behavior: reduce ? 'auto' : 'smooth' });
      mark(i);
    }

    if (prev) prev.addEventListener('click', function () { go(current - 1); restart(); });
    if (next) next.addEventListener('click', function () { go(current + 1); restart(); });

    // Aggiorna il pallino attivo anche con lo swipe
    var t;
    track.addEventListener('scroll', function () {
      clearTimeout(t);
      t = setTimeout(function () {
        var i = Math.round(track.scrollLeft / track.clientWidth);
        if (i !== current) mark(i);
      }, 80);
    }, { passive: true });

    // Autoplay opzionale (impostazione della sezione)
    var delay = parseInt(root.dataset.autoplay || '0', 10) * 1000;
    var timer = null;
    function stop() { clearInterval(timer); timer = null; }
    function start() {
      if (!delay || reduce) return;
      stop();
      timer = setInterval(function () { go(current + 1); }, delay);
    }
    function restart() { if (delay) start(); }

    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', start);
    document.addEventListener('visibilitychange', function () { document.hidden ? stop() : start(); });

    // Customizer: selezionando un blocco "Slide" lo slider si sposta su quella slide
    root.addEventListener('shopify:block:select', function (e) {
      var i = slides.indexOf(e.target);
      if (i > -1) { stop(); go(i); }
    });
    root.addEventListener('shopify:block:deselect', start);

    mark(0);
    start();
  }

  function initAll() {
    document.querySelectorAll('[data-hh-slider]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    init(e.target.querySelector('[data-hh-slider]'));
  });
})();
